import React from 'react';
import { LinkV2 } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';

export const HelpCenterLink = () => {
  const { t } = useTranslation('createWedding');

  return (
    <LinkV2 href="https://help.withjoy.com/" textDecoration="none" target="_blank" typographyVariant="hed3" color="linkText">
      {t('tyingTheKnot', 'helpCenter')()}
    </LinkV2>
  );
};
